
























































































































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class HelpItemLogin extends Vue {
  show = true
}
